import Vue from 'vue'
// import 'babel-polyfill'
import Vuetify from 'vuetify'
import VueClipboard from 'vue-clipboard2'
import VBodyScrollLock from 'v-body-scroll-lock'
import VueTelInput from './components/vue-tel-input'
import VueMq from 'vue-mq'
import store from '~/store'
import router from '~/router'
import { i18n } from '~/plugins'
import Main from './Main'
import IdleVue from 'idle-vue'
import '~/components'

if (!global._babelPolyfill) {
  require('babel-polyfill')
}

// css
import 'vue-horizontal-scroll/dist/vue-horizontal-scroll.css'
const eventsHub = new Vue()
Vue.use(Vuetify)
Vue.use(VueClipboard)
Vue.use(VBodyScrollLock)
Vue.use(VueTelInput)

// $mq, this.$mq， 方便搜索
Vue.use(VueMq, {
  breakpoints: {
    xs: 360,
    sm: 960,
    md: 1264,
    lg: 1904,
    xl: Infinity
  }
})
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 1800000 // 30 minutes
})

Vue.config.productionTip = false

new Vue({
  el: '#app',
  onIdle () {
    this.$store.dispatch('resetAllData')
    this.$store.dispatch('config/resetModeSelected')
    this.$store.dispatch('auth/logout')
    this.$router.push({ name: 'welcome' })
  },
  created () {
    let timestamp = Math.ceil((new Date()).getTime() / 1000)
    console.log('Now Timestamp is', timestamp, '.')
    this.$store.dispatch('config/setVisitAtTimestamp', timestamp)
  },
  i18n,
  store,
  router,
  ...Main
})



// WEBPACK FOOTER //
// ./src/app.js